class SwipeArea extends HTMLElement {
    get selectedIndex() {
        return Math.round(this.scrollLeft / this.offsetWidth);
    }

    set selectedIndex(index) {
        this.scroll({
            left: this.offsetWidth * index,
            behavior: 'smooth',
        });
    }

    get lastIndex() {
        return Math.floor(this.scrollWidth / this.offsetWidth) - 1;
    }

    get isSelectedFirst() {
        return this.selectedIndex === 0;
    }

    get isSelectedLast() {
        return this.selectedIndex === this.lastIndex;
    }

    swipe(direction = 1) {
        this.selectedIndex += direction;
    }
}

customElements.define('swipe-area', SwipeArea);
export default SwipeArea;
